function t(t){return!(!t||!t.__CANCEL__)}export{t as default};
//# sourceMappingURL=isCancel.js.map
